<template>
  <div style="cursor: move" v-if="window">
    <b-row
      :class="
        'col-lg-12 remove-window-spacing ' +
        (showModal ? 'window-width' : 'window-widthfixed')
      "
    >
      <b-col :class="showModal ? 'col-lg-4' : 'col-lg-0'" style="padding-right: 0px !important">
        <div class="notes_panel" v-show="showModal">
          <h6 class="notes-panel-title">
            <fa :icon="['fas', 'sticky-note']" class="mr-1" />
            <strong>Notes Template</strong>
          </h6>
          <div class="scroll-Container">
            <b-row v-for="element in ansi_notes" :key="element.id">
              <b-col class="my-1 mx-1">
                <b-button
                  title="Click to paste in Notes."
                  :key="element.note"
                  :id="element.id"
                  @click="pushToNotes(element.note)"
                  size="sm"
                  class="btn ansi-button text-left"
                  variant="btn-primary"
                >
                  * {{ element.note }}
                </b-button>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
      <b-col :class="showModal ? 'col-lg-8' : 'col-lg-12'" style="padding: 0">
        <div>
          <b-card class="panel" header-class="ansi-testing-header">
            <template #header>
              <div style="display: flex; align-items: center; gap: 6px;">
                <div style="flex: 1">
                  <b-button
                    id="submitAnsiBtn"
                    size="sm"
                    class="btn greenBtn"
                    variant="btn-primary"
                    block
                    @click="updateSite()"
                  >
                    Update
                  </b-button>
                </div>
                <div style="flex: 1">
                  <b-button
                    size="sm"
                    class="btn ansi-button"
                    variant="btn-primary"
                    id="togglePass"
                    block
                    @click="togglePass()"
                  >
                    Toggle Pass
                  </b-button>
                </div>
                <div style="flex: none; display: flex; align-items: center; padding-left: 4px;">
                  <button
                    type="button"
                    class="close-icon-btn"
                    title="Close"
                    aria-label="Close"
                    @click="closeWindow()"
                  >
                    <fa :icon="['fas', 'times']" />
                  </button>
                </div>
              </div>
            </template>
            <b-row class="info-grid mt-2">
              <b-row class="col-md-12 py-1 mx-3">
                <b-col class="col-md-6">
                  <label><b>SEGMENT ID: </b>{{ this.road_segment_id }}</label>
                </b-col>
                <b-col class="col-md-6">
                  <label><b>STATE: </b>{{ this.state_name }}</label>
                </b-col>
              </b-row>
              <b-row class="col-md-12 py-1 mx-3">
                <b-col class="col-md-6">
                  <label><b>TECHNICIAN: </b>{{ this.technician }}</label>
                </b-col>
                <b-col class="col-md-6">
                  <label><b>PART NUMBER: </b>{{ this.part_number }}</label>
                </b-col>
              </b-row>
              <b-row class="col-md-12 py-1 mx-3" v-if="lane_number || lane_type">
                <b-col v-if="lane_number" class="col-md-6">
                  <label><b>LANE NUMBER: </b>{{ this.lane_number }}</label>
                </b-col>
                <b-col v-if="lane_type" class="col-md-6">
                  <label><b>LANE TYPE: </b>{{ this.lane_type }}</label>
                </b-col>
              </b-row>
            </b-row>
            <b-row class="mx-2">
              <b-col>
                <b-row class="notesRow">
                  <label class="notes">Notes</label>
                  <fa
                    size="lg"
                    title="Open Notes Template"
                    class="greenBtn testingWindowNotes"
                    :icon="['fas', 'angle-down']"
                    @click="showNotesModal()"
                  />
                </b-row>
                <b-form-textarea
                  id="notes"
                  @mouseup="enableInput($event)"
                  @mousedown="enableInput($event)"
                  rows="4"
                  cols="50"
                  style="resize: none"
                  class="contenteditable-element"
                  v-model="notes"
                  ref="notes"
                ></b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="boxed section-bar py-1 px-4 mt-2" align-v="center">
              <b-col>
                <label class="section-title my-1">REQUIRED</label>
              </b-col>
            </b-row>
            <div class="scroll-Container">
              <b-row
                align-h="between"
                class="prop-row py-1 px-4 mt-2"
                v-for="prop in ansiProperties"
                :key="prop.id"
              >
                <b-col cols="8" class="p-2">
                  <span class="prop-name">
                    <strong>{{ prop.prop }}</strong>
                  </span>
                </b-col>
                <b-col cols="4">
                  <div class="btn-group btn-group-toggle" data-toggle="buttons">
                    <label
                      :class="
                        prop.value == 'not_validated'
                          ? 'btn dashed-border grayBtn'
                          : 'btn dashed-border unSelectedIcons'
                      "
                    >
                      <input
                        type="radio"
                        :checked="prop.value == 'not_validated'"
                        :name="prop.prop"
                        id="option1"
                        autocomplete="off"
                        value="not_validated"
                        title="Not Validated"
                        @change="changed($event, prop.prop)"
                      />
                      <span
                        class="glyphicon glyphicon-eye-close"
                        title="Not Validated"
                      >
                        <fa :icon="['fas', 'eye-slash']" />
                      </span>
                    </label>
                    <label
                      :class="
                        prop.value == 'indeterminate'
                          ? 'btn dashed-border yellowBtn'
                          : 'btn dashed-border unSelectedIcons'
                      "
                    >
                      <input
                        type="radio"
                        :checked="prop.value == 'indeterminate'"
                        :name="prop.prop"
                        id="option2"
                        autocomplete="off"
                        value="indeterminate"
                        title="Indeterminate"
                        @change="changed($event, prop.prop)"
                      />
                      <span
                        class="glyphicon glyphicon-warning-sign"
                        title="Indeterminate"
                      >
                        <fa :icon="['fas', 'exclamation-triangle']" />
                      </span>
                    </label>
                    <label
                      :class="
                        prop.value == 'fail'
                          ? 'btn dashed-border redBtn'
                          : 'btn dashed-border unSelectedIcons'
                      "
                    >
                      <input
                        type="radio"
                        :checked="prop.value == 'fail'"
                        :name="prop.prop"
                        id="option3"
                        autocomplete="off"
                        value="fail"
                        title="Fail"
                        @change="changed($event, prop.prop)"
                      />
                      <span class="glyphicon glyphicon-thumbs-down" title="Fail">
                        <fa :icon="['fas', 'thumbs-down']" />
                      </span>
                    </label>
                    <label
                      :class="
                        prop.value == 'pass'
                          ? 'btn dashed-border greenBtn'
                          : 'btn dashed-border unSelectedIcons'
                      "
                    >
                      <input
                        type="radio"
                        :checked="prop.value == 'pass'"
                        :name="prop.prop"
                        id="option4"
                        autocomplete="off"
                        value="pass"
                        title="Pass"
                        @change="changed($event, prop.prop)"
                      />
                      <span class="glyphicon glyphicon-thumbs-up" title="Pass">
                        <fa :icon="['fas', 'thumbs-up']" />
                      </span>
                    </label>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'MMP_Biased_Testing',
  props: ['apiUrl', 'layerDefinition','clickedLayerName', 'user'],
  data() {
    return {
      ansiProperties: [],
      window: true,
      ansi_notes: [],
      getApiUrl: '/api/' + this.apiUrl,
      notes: null,
      opts: [],
      part_number: null,
      properties: [],
      required_props: [],
      road_type: null,
      road_segment_id: null,
      showModal: false,
      state_name: null,
      technician: null,
      ushrId: null,
      osm_id: null,
      validateOverallStatus: null,
      id: null,
      lane_number: null,
      lane_type:null,
    }
  },
  methods: {
    closeWindow() {
      this.window = false
      this.$emit('closeBiasedAnsiTestingWindow')
    },
    updateSite() {
      let opts = []
      this.ansiProperties.forEach(ob => {
        opts.push(ob.prop, ob.value)
      })
      // Flatten the array
      opts = opts.flat()
      // Create an empty object
      let obj = {}
      for (let i = 0; i < opts.length; i++) {
        if (i % 2 == 0) {
          // Extract the key and the value
          let key = opts[i]
          let value = opts[i + 1]
          // Assign the key and value
          obj[key] = value
        }
      }
      let opts_param = {
        table: this.clickedLayerName,
        region:this.state_name,
        technician:this.user.name,
        overall:this.getStatus(),
        notes: this.notes,
        id:this.id
      }
      this.validateOverallStatus = opts_param.overall
      if (this.validateOverallStatus != 'not_validated') {
        var mergedObj = Object.assign(obj, opts_param)
        axios
          .get(
            process.env.API_LOCATION + this.getApiUrl + '/updateBiasedANSI',
            {
              method: 'post',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {mergedObj}
            }
          )
          .then(response => {
            const content = response.data
            this.$bvToast.toast('Entry saved.', {
              title: 'BIASED ANSI Submission Status',
              toaster: 'b-toaster-bottom-center'
            })
          })
          .catch(function (error) {
            console.log(error)
          })
        this.closeWindow()
      } else {
        this.$bvToast.toast('Please confirm BIASED ANSI is validated.', {
          title: 'BIASED ANSI Submission Status',
          toaster: 'b-toaster-bottom-center'
        })
      }
    },
    getStatus() {
      var values = []
      this.ansiProperties.forEach(radios => {
        values.push({name: radios.value})
      })
      if (
        values.filter(e => e.name === 'not_validated')
          .length > 0
      ) {
        return 'not_validated'
      } else if (values.filter(e => e.name === 'fail').length > 0) {
        return 'fail'
      } else {
        return 'pass'
      }
    },
    togglePass() {
      this.properties = []
      this.properties = this.ansiProperties
      this.ansiProperties = []
      this.properties.forEach(val => {
        this.ansiProperties.push({
          prop: val.prop,
          value: 'pass'
        })
      })
    },
    /* loadAnsiData function gets the data generated by the single-click event
       from parent and renders the data in the ANSI Testing Window */
    loadAnsiData(data) {
      if (data != null) {
        this.window = true
        var feature = data.properties
        this.road_segment_id = feature.road_segment_id
        this.state_name = feature.region
        this.road_type = feature.type
        this.technician = feature.technician
        this.lane_number = feature.lane_number
        this.lane_type = feature.lane_type_attribute
        this.notes = feature.notes
        this.part_number = feature.part_number
        this.id = feature.id
        this.overall = feature.overall
        this.ansiProperties = []
        this.ansiProperties.push({
          prop:this.getProp(this.clickedLayerName.split('.')[0]),
          value:this.overall,
          type: 'required',
          id: this.id
        })
      }
    },
    changed(e, prop) {
      var checkedLabel = e.target
      const index = this.ansiProperties.findIndex(item => {
        return prop === item.prop
      })
      this.ansiProperties[index].value = checkedLabel.value
    },
    enableInput(e) {
      /* Vue-Moveable js disabled the left-click event in order to increase convenience
      for dragging the window and enabled right-click to set the focus on textarea and
      input box, hence this function resets that. */
      e.target.contentEditable = 'true'
      this.$refs.notes.focus()
    },
    getAnsiNotes() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/ansi_notes/getAnsiNotes', {
            method: 'GET',
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              this.$router.push({name: 'Login'})
            } else {
              this.ansi_notes = content
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.feedback = 'No Apps For you'
        this.$router.push({name: 'Login'})
      }
    },
    pushToNotes(value) {
      this.notes = value
      this.showModal = false
    },
    showNotesModal() {
      this.showModal = !this.showModal
    },
    getProp(propValue) {      
      let propResult
      switch (propValue) {
        case 'biased_added':
          propResult = 'Added'
          break
        case 'biased_diverging':
          propResult = 'Diverging'
          break       
        case 'biased_end':
          propResult = 'End of Map'
          break
        case 'biased_start':
          propResult = 'Start of Map'
          break
        case 'biased_ending':
          propResult = 'Ending'
          break
        case 'biased_merging':
          propResult = 'Merging'
          break
      }     
      return propResult
    }
  },
  mounted() {
    this.getAnsiNotes()
  },
  updated() {
    this.$emit('ansiTestingDataUpdated')
  }
}
</script>

<style scoped>
/* ── Card shell ─────────────────────────────────────────── */
.panel {
  max-height: 90vh;
  background: #ffffff;
  color: #063c6d;
  border: 1px solid rgba(6, 60, 109, 0.12);
  border-radius: 14px;
  box-shadow: 0 12px 40px rgba(4, 30, 58, 0.28);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.panel ::v-deep(.card-body) {
  padding: 14px 16px 16px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
.scroll-Container {
  flex: 1 1 auto;
  min-height: 0;
  max-height: 40vh;
  overflow-y: auto;
  overflow-x: hidden;
}

/* ── Header ─────────────────────────────────────────────── */
.ansi-testing-header {
  color: white !important;
  padding: 10px 14px;
  border-bottom: none !important;
}
.ansi-testing-header .btn {
  color: white !important;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.82rem;
  letter-spacing: 0.02em;
  padding: 6px 10px;
  transition: filter 0.15s ease, transform 0.12s ease, box-shadow 0.15s ease;
}
.ansi-testing-header .btn:hover {
  filter: brightness(1.08);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}
.ansi-testing-header .btn:active {
  transform: translateY(0);
}
.ansi-testing-header .close-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgb(18, 67, 172);
  color: #ffffff;
  font-size: 0.9rem;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease,
    box-shadow 0.15s ease;
}
.ansi-testing-header .close-icon-btn:hover {
  background: #e5484d;
  color: #ffffff;
  transform: scale(1.1);
  box-shadow: 0 3px 10px rgba(229, 72, 77, 0.45);
}
.ansi-testing-header .close-icon-btn:active {
  transform: scale(0.95);
}
.ansi-testing-header .close-icon-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35);
}

/* ── Read-only info grid ────────────────────────────────── */
.info-grid {
  background: rgba(6, 60, 109, 0.045);
  border: 1px solid rgba(6, 60, 109, 0.08);
  border-radius: 10px;
  padding: 4px 6px;
  margin-left: 2px;
  margin-right: 2px;
}
.info-grid label {
  display: block;
  margin: 0;
  font-size: 0.85rem;
  color: #063c6d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.info-grid b {
  display: block;
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(6, 60, 109, 0.55);
  margin-bottom: 1px;
}

/* ── Notes ──────────────────────────────────────────────── */
.notesRow {
  padding-left: 15px;
  align-items: center;
  color: #063c6d;
  margin-top: 10px;
  margin-bottom: 10px;
}
.notes {
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 0.02em;
  margin: 8px 0 4px;
}
.testingWindowNotes {
  margin-left: 6px;
  cursor: pointer;
}
.contenteditable-element {
  user-select: text;
  background: #f3f5f8 !important;
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  border-radius: 8px !important;
  color: #063c6d !important;
  resize: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}
.contenteditable-element:focus {
  background: #fff !important;
  border-color: #0a5499 !important;
  box-shadow: 0 0 0 3px rgba(10, 84, 153, 0.15) !important;
  outline: none;
}

/* ── Section headers (REQUIRED) ──────────────────────────── */
.boxed {
  background: rgba(6, 60, 109, 0.06);
  border: none !important;
  border-radius: 8px;
  color: #063c6d;
}
.section-bar {
  border-left: 3px solid #0a5499 !important;
  margin-top: 15px !important;
}
.section-title {
  display: inline-block;
  margin: 4px 0;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #063c6d;
}

/* ── Property rows ──────────────────────────────────────── */
.prop-row {
  border-radius: 8px;
  transition: background 0.12s ease;
}
.prop-row:hover {
  background: rgba(10, 84, 153, 0.05);
}
.prop-name {
  font-size: 0.9rem;
  color: #063c6d;
}

/* ── Toggle button group (segmented control) ────────────── */
.btn-group-toggle {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(6, 60, 109, 0.12);
}
.btn-group-toggle .btn {
  color: #063c6d;
  border: 1px solid rgba(6, 60, 109, 0.15);
  padding: 5px 12px;
  transition: background 0.15s ease, color 0.15s ease, transform 0.1s ease;
}
.btn-group-toggle .btn:hover {
  transform: translateY(-1px);
}
.unSelectedIcons {
  background: #f3f5f8 !important;
  color: rgba(6, 60, 109, 0.65) !important;
}
.unSelectedIcons:hover {
  background: #e6edf5 !important;
  color: #063c6d !important;
}
.dashed-border {
  border: 1px dashed rgba(6, 60, 109, 0.35);
}

/* ── Notes template side panel ──────────────────────────── */
.notes_panel {
  background: linear-gradient(180deg, #f7f9fc 0%, #eef2f8 100%);
  border-radius: 12px;
  padding: 6px 8px 10px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6),
    0 4px 14px rgba(4, 30, 58, 0.08);
}
.notes-panel-title {
  position: sticky;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: -6px -8px 8px;
  padding: 8px 10px;
  font-size: 0.82rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #ffffff;
  background: linear-gradient(135deg, #0a5499, #063c6d);
  border-radius: 12px 12px 0 0;
  box-shadow: 0 2px 8px rgba(6, 60, 109, 0.25);
}
.notes-panel-title .svg-inline--fa {
  opacity: 0.85;
}
.notes_panel .ansi-button {
  width: 100%;
  border-radius: 8px;
  white-space: normal;
  font-size: 0.8rem;
  line-height: 1.3;
  padding: 8px 10px;
  color: #063c6d !important;
  background: #ffffff !important;
  border: 1px solid rgba(6, 60, 109, 0.14) !important;
  box-shadow: 0 1px 2px rgba(6, 60, 109, 0.06);
  transition: background 0.15s ease, border-color 0.15s ease,
    box-shadow 0.15s ease, transform 0.12s ease;
}
.notes_panel .ansi-button:hover {
  background: #f0f6ff !important;
  border-color: #0a5499 !important;
  box-shadow: 0 4px 12px rgba(10, 84, 153, 0.18);
  transform: translateY(-1px);
}
.notes_panel .ansi-button:active {
  transform: translateY(0);
  box-shadow: 0 1px 3px rgba(10, 84, 153, 0.2);
}

/* ── Window sizing ──────────────────────────────────────── */
.window-widthfixed {
  width: min(40.625rem, 90vw) !important;
}
.window-width {
  width: min(57.5rem, 90vw) !important;
}
.remove-window-spacing {
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;
  margin-right: 0;
}
.btn {
  color: #063c6d;
}
</style>
